import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import n from "./mallSpApprovalTrigger.ce.vue.js";
import { vCopyVueucStylesToShadowDom as s } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { vShadowPropertyPolyfill as c } from "../../utils/vShadowPropertyPolyfill.js";
import { useShadowRoot as d } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import u from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import C from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import _ from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import { NDialogProvider as g } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/dialog/src/DialogProvider.js";
import v from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
import { defineComponent as y, useTemplateRef as h, withDirectives as P, openBlock as w, createBlock as N, withCtx as t, createVNode as m } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const O = /* @__PURE__ */ y({
  name: "MallSpApprovalTriggerEntry",
  __name: "index.ce",
  setup(R, { expose: p }) {
    const i = h("triggerRef"), e = d(), f = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    };
    return p({ open: (a) => {
      var r, l;
      return (l = (r = i.value) == null ? void 0 : r.open(a)) != null ? l : Promise.resolve(!1);
    } }), (a, r) => P((w(), N(o(_), {
      locale: o(u),
      "date-locale": o(C),
      "theme-overrides": f,
      "style-mount-target": o(e)
    }, {
      default: t(() => [
        m(o(v), { to: o(e) }, {
          default: t(() => [
            m(o(g), { to: o(e) }, {
              default: t(() => [
                m(n, {
                  ref_key: "triggerRef",
                  ref: i
                }, null, 512)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [o(s), o(e)],
      [o(c), o(e)]
    ]);
  }
});
export {
  O as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/mall-sp-approval-trigger/index.ce.vue2.js
// module id = 1304
// module chunks = 67